import EventWithoutSeasonMapper from './event-without-season-mapper';
import SportEventModel from '../sport-event/sport-event-model';

const EventWithoutSeasonModel = {
    mapper: EventWithoutSeasonMapper,

    count: {
        type: Number,
    },

    events: {
        model: SportEventModel,
        type: Array,
    },
};

export default EventWithoutSeasonModel;
